import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const http = axios.create({ baseURL: API, withCredentials: true });

export const fetchDeck = () => http.get("/deck").then((r) => r.data);
export const fetchStats = () => http.get("/stats").then((r) => r.data);
export const fetchLeaderboard = () => http.get("/leaderboard?limit=20").then((r) => r.data);
export const submitScore = (payload) => http.post("/scores", payload).then((r) => r.data);
export const generateCards = (count = 3) => http.post("/cards/generate", { count }).then((r) => r.data);

export const exchangeSession = (session_id) => http.post("/auth/session", { session_id }).then((r) => r.data);
export const fetchMe = () => http.get("/auth/me").then((r) => r.data);
export const apiLogout = () => http.post("/auth/logout").then((r) => r.data);
